// extracted by mini-css-extract-plugin
module.exports = {"attendees":"styles_attendees__2DTcy"};